import { gsap, ScrollTrigger } from "gsap/all";
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(ScrollTrigger);

let __animateOnScroll = (selector, animation) => {

    let target = document.querySelector(selector);

    let options = {
        rootMargin: '0px',
        threshold: 0.5
    }
    target.timeline = animation;
    let __trigger = (entries, observer) =>
    {
        entries.forEach(entry => {
            // console.log(observer);
            if(entry.isIntersecting){
                // console.log('coming into view');
                target.timeline.play();
            } else {
               // console.log('leaving the view');
                target.timeline.reverse();
            }
        });
    }
    let observer = new IntersectionObserver( __trigger, options );
    observer.observe(target);


}

(function($){

    $(document).ready(function(){
        console.log('document ready');
        __menuTrigger();

        __resizeEvents();

        $(window).resize(function(){
            console.log(window.innerHeight);
        });

        $(window).scroll(function(e){
            if( $(window).scrollTop() != 0 )
            {
                $('.nav--secondary').addClass('show');
            } else {
                $('.nav--secondary').removeClass('show');
            }
        });

    });

    let __menuTrigger = () => {
        $('.nav__mobile-trigger').click((e) => {
            e.preventDefault();
            $('.nav--primary').toggleClass('nav--open');
        });
    }

    let __registerAnimations = () => {

        let overviewAnim, featuresAnim, howitworksAnim;

        if($('.product__overview').length > 0){
            overviewAnim = gsap.timeline({ paused: true })
                .fromTo( '.product__overview .animatable', 0.75, { drawSVG: '0%',}, { drawSVG: '100%', ease: 'power2.inOut' }, 0.35 )
                .fromTo( '.product__overview-section-pullquote', 0.75, { y: 50, autoAlpha: 0}, { y: 0, autoAlpha: 1 }, 0.2 )
                .fromTo( '.product__overview-section-title', 0.5, { y: 100, autoAlpha: 0}, { y: 0, autoAlpha: 1 }, 0)
                .fromTo( '.product__overview-section-description', 0.5, { x: -100, autoAlpha: 0}, { x: 0, autoAlpha: 1 }, 0.2);
        }

        if($('.product__features-item').length > 0){
            featuresAnim = gsap.timeline({ paused: true }).staggerFromTo('.product__features-item', 0.3, { y: 100, autoAlpha: 0, duration: 1.5 }, { y:0, autoAlpha: 1 }, 0.2);
        }

        if($('.product__howitworks').length > 0){
            howitworksAnim = gsap.timeline({ paused: true })
                    .staggerFromTo('.product__howitworks-img', 0.2, { autoAlpha: 0 }, { autoAlpha:1, delay: 0.2 }, 0.4, 0.45)
                    .staggerFromTo('.product__howitworks-text', 0.3, { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, 0.45, 0 )
                    .staggerFromTo('.product__howitworks-section-indicator', 0.3, { scale: 0 }, { scale: 1 }, 0.5, 0 )
                    .staggerFromTo('.product__howitworks .animatable', 0.75, { drawSVG: '0%',}, { drawSVG: '100%' }, 0.5);
        }

        return { overviewAnim : overviewAnim, featuresAnim: featuresAnim, howitworksAnim: howitworksAnim }
    }



    let __resizeEvents = () => {

            let animations = __registerAnimations();

            if($('.product__overview').length > 0){
                animations.overviewAnim.play();
            }
            if($('#features').length)
            {
                __animateOnScroll('#features', animations.featuresAnim);
            }
            if($('#how').length){
                __animateOnScroll('#how', animations.howitworksAnim);
            }
            __productOverview();

    }


    let __productOverview = () => {
        __fixImage();
        __fixText();
    }

    let __fixText = () => {

        gsap.utils.toArray(".product__overview-section").forEach((panel, i) => {
            let image_url = $(panel).data('image');
            ScrollTrigger.create({
                trigger: panel,
                pin: true,
                start: "top 20%",
                end: "bottom 20%",
                //markers: true,
                onToggle: self => {
                    // console.log("toggled, isActive:", self.isActive)
                    if(self.isActive)
                    {
                        $('.product__overview-img').attr('src',image_url);
                        $('.product__overview-img').removeAttr('srcset');
                    }
                },
                onUpdate: self => {
                    // console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
                }
            })
        });
    }

    let __fixImage = () => {

        console.log('running fixImage');

        if( $('.product__overview-img').length > 0 ){

            console.log('we have an image');

            let imageHeight = $('.product__overview-img').height();

            let vh = window.innerHeight /100;

            let height = ((67 * vh) * 5);

            let sections = $('.product__overview-section');
            let sectionHeight = 0;

            $.each(sections,function(index,section){
                sectionHeight = sectionHeight + $(section).outerHeight(true);
            });

            ScrollTrigger.create({
                trigger: '.product__overview-img',
                pin: true,
                start: "top 20%",
                // markers: true,
                end:  '+=' + (sectionHeight + (50 * vh))
            });
        }
    }



})(jQuery);




